<ngx-slider [(value)]="minValue"
            [(highValue)]="maxValue"
            [options]="options"
            (userChangeEnd)="emmitSliderEvent()"></ngx-slider>
